export const useAddSrpFragmentToLink = (): Record<string, (link: string) => boolean | string> => {
  const addSrpFragmentToLink = (link: string) => (isSrpLink(link) && !link.includes('#') ? `${link}#vehicles` : link);

  const isSrpLink = (link = ''): boolean => link.includes('sort=');

  return {
    addSrpFragmentToLink,
    isSrpLink,
  };
};
